import React, { Fragment } from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import { Layout, Row, Rows, Section } from '@/components/layout'
import { Text } from '@/components/common'
import neatLogo from '@/assets/neat-competitor/neat-logo.png'
import checkIcon from '@/assets/neat-competitor/check-icon.png'
import crossIcon from '@/assets/neat-competitor/cross-icon.png'

import styles from './FeatureComparison.module.scss'

export default function FeatureComparison({
  title,
  competitorLogo,
  featureComparison = [],
}) {
  return (
    <Layout.Content>

      {featureComparison.length > 0 && (
        <div className={styles.featureComparison}>
          <Section paddingBottom={0}>
            <Rows gap={12} maxWidth={800}>
              <Row center textCenter>
                <Text.H2 className="c-brand" style={{ marginBottom: '30px' }}>{title}</Text.H2>
              </Row>
            </Rows>
          </Section>

          <Section className={styles.comparison} paddingBottom={24}>
            <Rows className={styles.comparisonWrap}>
              <div className={styles.comparisonGrid}>
                <div className={styles.compareRowTitle} />

                <div className={styles.compareNeat}>
                  <Image alt="Neat" src={neatLogo} />
                </div>

                <div className={styles.compareCompetitor}>
                  <Image alt="Neat" src={competitorLogo} />
                </div>

                {featureComparison.map(comparison => (
                  <Fragment key={comparison.feature}>
                    <div className={styles.compareRowTitle}>
                      <Text.H3 className={styles.title}>{comparison.feature}</Text.H3>
                    </div>

                    <div className={styles.compareNeat}>
                      <Image alt={comparison.neat ? 'Included' : 'Not Included'} src={comparison.neat ? checkIcon : crossIcon} width="24" />
                    </div>

                    <div className={styles.compareCompetitor}>
                      <Image alt={comparison.competitor ? 'Included' : 'Not Included'} src={comparison.competitor ? checkIcon : crossIcon} width="24" />
                    </div>
                  </Fragment>
                ))}
              </div>
            </Rows>
          </Section>
        </div>
      )}

    </Layout.Content>
  )
}

FeatureComparison.propTypes = {
  title: PropTypes.string.isRequired,
  competitorLogo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  featureComparison: PropTypes.arrayOf(PropTypes.shape({
    rowTitle: PropTypes.string,
    neat: PropTypes.bool,
    competitor: PropTypes.bool,
  })),
}
